/*globals ko*/

var RangeSlider = (function ($) {
  //'use strict';

  ko.bindingHandlers.rangeSlider = {
    update: function (element, valueAccessor, allBindingsAccessor, viewModel) {
      var widgetBindings = _getWidgetBindings(element, valueAccessor, allBindingsAccessor, viewModel),
          $elem = null,
          $elemContainer = null,
          $sliderBarElem = null;

      $(element)[widgetBindings.widgetName](widgetBindings.widgetOptions);

      //Update slider when bindings such as a default button clicked or input changed update slider
      $elem = $(element);
      $elemContainer = $elem.prev();
      $sliderBarElem = $('.irs-bar, .irs-line');

      //prevent clicking and touching on slider bar only allow draggin of handles and labels (causes problems on double sliders)
      $sliderBarElem.off('mousedown mouseup touchstart touchend');

      //Used for Expense Sliders where there is an input box that allows you to go outside of the range.
      if ($elem.data('slider-type') !== 'goal-ages') {
        if (valueAccessor().options.from > valueAccessor().options.max) {
          $elemContainer.find('.irs-slider').css('left', '95%');
          $elemContainer.find('.irs-bar').css('width', '95%');
          $elemContainer.find('.irs-single').text('> Range').css('left', '85%');
        }
        else if (valueAccessor().options.from < valueAccessor().options.min) {
          $elemContainer.find('.irs-slider').css('left', '0%');
          $elemContainer.find('.irs-bar').css('width', '0%');
          $elemContainer.find('.irs-single').text('< Range').css('left', '0%');
        }
      }

      ////Used to set web accessibility
      RangeSlider.SetWebAccessibilityAttributes($elemContainer, valueAccessor().options);
      RangeSlider.SetTabKeyUpEvent();
    }
  };

  function _getWidgetBindings(element, valueAccessor) {
    var value = valueAccessor(),
            myBinding = ko.utils.unwrapObservable(value);
            //allBindings = allBindingsAccessor();

    if (typeof (myBinding) === 'string') {
      myBinding = { 'widget': myBinding };
    }

    var widgetName = myBinding.widget,
            widgetOptions = myBinding.options; // ok if undefined

    return {
      widgetName: widgetName,
      widgetOptions: widgetOptions
    };
  }

  return {
    OrigFocusedElem : null,

    SetUpMarkers: function ($slider, minValue, maxValue, currentValue, markerId) {
      var DEFAULT_MARKER_WIDTH = 16,
        sliderRange = maxValue - minValue,
        gridWidth,
        markerWidth,
        pixelsPerUnit,
        unitsFromMin,
        leftPct,
        $markerElem = null;

      gridWidth = $slider.find('.irs-grid').width();
      pixelsPerUnit = gridWidth / sliderRange;
      unitsFromMin = currentValue - minValue;
      leftPct = ((pixelsPerUnit * unitsFromMin) / gridWidth) * 100 + '%';
      $markerElem = $('#' + markerId);
      markerWidth = $markerElem.innerWidth() > 0 ? $markerElem.innerWidth() : DEFAULT_MARKER_WIDTH;
      $markerElem.css('left', leftPct).css('margin-left', -(markerWidth / 2));
    },

    DefaultMarkers: function ($elem, minValue, maxValue, currentValue, markerPosition, tooltip, onUpdate, piiType) {
      var markerClass = 'marker ' + markerPosition,
        markerId = 'marker_' + Math.floor(Math.random() * 10001);
        dataMaskClass = typeof (Settings.DataMaskClass) !== 'undefined' ? DataObfuscation.ApplyClassName(piiType) : '';

      $elem.find('.irs-grid').append(
          '<div id=' + markerId + ' class="' + markerClass + ' slider-tooltip" data-original-title="<span class=' + dataMaskClass + '>' + tooltip + '</span>' +
          '" data-container="body" data-html="true" data-toggle="tooltip" tabindex="0" data-trigger="hover focus"><span></span>' +
          '<span class="sr-only">' + tooltip + '</span></div>' //this line is for web accessibility
      );
     
      //gridWidth is not set correctly if not in a self-executing anonymous function
      (function () {
        RangeSlider.SetUpMarkers($elem, minValue, maxValue, currentValue, markerId);
        $('#' + markerId).tooltip();
      }());

      if (onUpdate) {
        RangeSlider.SetUpMarkers($elem, minValue, maxValue, currentValue, markerId);
      }
    },

    SetUpTickmarks: function ($slider, minValue, maxValue, tickMarkValues) {
      var sliderRange = maxValue - minValue,
        gridWidth,
        pixelsPerUnit,
        unitsFromMin,
        leftPct,
        $tickMarkElem;

      $('.tickmark').remove();

      gridWidth = $slider.find('.irs-grid').width();
      pixelsPerUnit = gridWidth / sliderRange;

      for (var i = 0; i < tickMarkValues.length; i++) {
        unitsFromMin = tickMarkValues[i] - minValue;
        leftPct = ((pixelsPerUnit * unitsFromMin) / gridWidth) * 100;

        $slider.find('.irs-grid').append(
         '<div class="tickmark" aria-hidden="true"><span>|</span></div>');

        $tickMarkElem = $slider.find('.tickmark').eq(i);
        if (leftPct <= 100) {
          $tickMarkElem.css('left', leftPct + '%').css('margin-left', -($tickMarkElem.innerWidth() / 2));
        }
      }
    },

    DefaultTickmarks: function ($elem, minValue, maxValue, tickMarkValues, onUpdate) {

      //gridWidth is not set correctly if not in a self-executing anonymous function
      (function () {
        RangeSlider.SetUpTickmarks($elem, minValue, maxValue, tickMarkValues);
      }());

      if (onUpdate) {
        RangeSlider.SetUpTickmarks($elem, minValue, maxValue, tickMarkValues);
      }
    },

    StepInterval: function (max, percent) {
      var median = max / 2,
          valLength = median.toFixed().length,
          step;

      switch (valLength) {
        case 0:
        case 1:
        case 2:
          step = percent ? max > 50 ? 0.50 : 0.25 : 1;
          break;

        case 3:
          step = 10;
          break;

        case 4:
          step = 100;
          break;

        case 6:
        case 5:
          step = 1000;
          break;

        case 7:
          step = 10000;
          break;

        default:
          step = 1000;
          break;
      }
      return step;
    },

    SetGridNum: function (range) {
      var arrayRange = [],
          arrayDivisible = [],
          index = 0,
          DEFAULT_GRID_NUM = 4; //ion range slider default

      //Set all values of range array 
      for (var i = 0; i < range; ++i) {
        arrayRange[i] = i;
      }
      
      //Get all numbers divisible with the range value
      for (var i = 0; i < range; i++)
      {
        if (range % arrayRange[i] === 0)
        {
          arrayDivisible[index++] = i;
        }
      }
      
      //Find the closest divisible number to DEFAULT_GRID_NUM
      if (arrayDivisible.length > 0) {
        return arrayDivisible.reduce(function (prev, curr) {
          return (Math.abs(curr - DEFAULT_GRID_NUM) < Math.abs(prev - DEFAULT_GRID_NUM) ? curr : prev);
        });
      }
      else {
        return DEFAULT_GRID_NUM;
      }
    },

    SetKeyboardStepPct: function (range, step) {
      var gridWidthPct = 95,
          sliderStep = step ? step : 1;

      if (range > gridWidthPct) {
        var divisor = RangeSlider.StepInterval(range);
        return (gridWidthPct / (range / divisor));
      }
      return gridWidthPct / (range / sliderStep);
    },

    SetWebAccessibilityAttributes: function ($elemContainer, data) {
      var labeledById = 'slider-label-' + $elemContainer.closest('.slider-container').attr('id'),
          $irsSliderFrom = $elemContainer.find('.irs-slider.from'),
          $irsSliderTo = $elemContainer.find('.irs-slider.to'),
          $irsSliderSingle = $elemContainer.find('.irs-slider.single');

      //Used to set web accessibility for slider handles
      $irsSliderFrom.attr('tabindex', '0')
        .attr('role', 'slider').attr('aria-label', 'minimum value')
        .attr('aria-valuemin', data.min).attr('aria-valuemax', data.max);

      $irsSliderTo.attr('tabindex', '0')
        .attr('role', 'slider').attr('aria-label', 'maximum value')
        .attr('aria-valuemin', data.min).attr('aria-valuemax', data.max);

      $irsSliderSingle.attr('tabindex', '0')
        .attr('role', 'slider').attr('aria-label', 'value')
        .attr('aria-valuemin', data.min).attr('aria-valuemax', data.max);

      //Set aria-describedby on init only
      if (RangeSlider.OrigFocusedElem === null) {
        $irsSliderFrom.attr('aria-describedby', labeledById);
        $irsSliderSingle.attr('aria-describedby', labeledById);
      }

      $elemContainer.find('.irs-grid-text').attr('aria-hidden', 'true');

      RangeSlider.UpdateWebAccessibilityAttributes($elemContainer, data);
    },

    UpdateWebAccessibilityAttributes: function ($elemContainer, data) {
      var
        fromVal = data.from,
        toVal = data.to,
        singleVal = data.from,
        fromValText = $elemContainer.find('.irs-from').text(),
        toValText = $elemContainer.find('.irs-to').text(),
        singleValText = $elemContainer.find('.irs-single').text(),
        fromLabelSub = '',
        toLabelSub = '',
        singleLabelSub = '',
        $fromLabel = $elemContainer.find('.irs-from-label'),
        $toLabel = $elemContainer.find('.irs-to-label'),
        $singleLabel = $elemContainer.find('.irs-single-label'),
        $fromLabelSub = $elemContainer.find('.irs-from-label-sub'),
        $toLabelSub = $elemContainer.find('.irs-to-label-sub');

      if ($fromLabel.length) {
        fromVal = $fromLabel.text().replace(/\D/g, '');

        if ($fromLabelSub.length) {
          fromLabelSub = $fromLabelSub.data('prefix-desc') + $fromLabelSub.text();
        }
        fromValText = $fromLabel.text() + fromLabelSub;
      }
      if ($toLabel.length) {
        toVal = $toLabel.text().replace(/\D/g, '');

        if ($fromLabelSub.length) {
          toLabelSub = $toLabelSub.data('prefix-desc') + $toLabelSub.text();
        }

        toValText = $toLabel.text() + toLabelSub;
      }
      if ($singleLabel.length) {
        singleVal = $singleLabel.text().replace(/\D/g, '');

        if ($fromLabelSub.length) {
          singleLabelSub = $toLabelSub.data('prefix-desc') + $toLabelSub.text();
        }

        singleValText = $singleLabel.text() + singleLabelSub;
      }

      $elemContainer.find('.irs-slider.from')
        .attr('aria-valuenow', fromVal).attr('aria-valuetext', fromValText);
      $elemContainer.find('.irs-slider.to')
        .attr('aria-valuenow', toVal).attr('aria-valuetext', toValText);
      $elemContainer.find('.irs-slider.single')
        .attr('aria-valuenow', singleVal).attr('aria-valuetext', singleValText);

      if (RangeSlider.OrigFocusedElem)
        setTimeout(function () { RangeSlider.OrigFocusedElem.trigger('focus'); }, 2000);
    },

    SetTabKeyUpEvent: function () {
      $('.irs-slider.from, .irs-slider.to, .irs-slider.single').on('keyup', function (e) {
        var code = parseInt(e.keyCode ? e.keyCode : e.which),
          tabKeyCode = 9,
          $focusedElem = $(':focus'),
          elemOffset = $focusedElem.offset();

        if (code === tabKeyCode) {
          //if ($focusedElem.hasClass('irs-slider')) {
            //if ($focusedElem.is('.from, .to, .single')) {
              if (!$focusedElem.hasClass('irs-visited')) {
                $focusedElem.trigger($.Event('mousedown', { pageX: elemOffset.left, pageY: elemOffset.top }));
                $focusedElem.trigger($.Event('mouseup', { pageX: elemOffset.left, pageY: elemOffset.top }));
                $focusedElem.addClass('irs-visited');

                setTimeout(function () { $focusedElem.trigger('focus'); }, 0);

                RangeSlider.OrigFocusedElem = $focusedElem;
              }
              else {
                $('.irs-slider').removeClass('irs-visited');
              }
            //}
          //}
        }
        else {
          switch (code) {
            case 83: // W
            case 65: // A
            case 40: // DOWN
            case 37: // LEFT
            case 87: // S
            case 68: // D
            case 38: // UP
            case 39: // RIGHT
              //if ($focusedElem.hasClass('irs-slider')) {
                //Remove aria-describedby slider handle move so it doesn't read every time the slider is moved
                $focusedElem.removeAttr('aria-describedby');

                $focusedElem.trigger($.Event('mousedown', { pageX: elemOffset.left, pageY: elemOffset.top }));
                $focusedElem.trigger($.Event('mouseup', { pageX: elemOffset.left, pageY: elemOffset.top }));
              //}
          }
        }
      });
    }
  };

}(jQuery, ko));
